import { render, staticRenderFns } from "./OtherIncomeCreation.vue?vue&type=template&id=20c9ed4e&scoped=true"
import script from "./OtherIncomeCreation.vue?vue&type=script&lang=js"
export * from "./OtherIncomeCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c9ed4e",
  null
  
)

export default component.exports